import React, { useContext } from 'react'
import { Box, Button, LinearProgress } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import moment from 'moment';
import RightTickImg from '../assets/right_tick_img.svg'
import { GlobalStateContext } from '../context/globalStateProvider';
import { CAR_HANDOVER, CAR_ARRIVED } from '../utils/shareData';

const VisibleActivities = (props) => {
  const {setViewAllActivities} = useContext(GlobalStateContext)
  const { bindDrag, currentActivity, visibleActivities, activitiesPercentage } = props
  const theme = useTheme();
  if(currentActivity.name === CAR_HANDOVER) return null
  return (
      <Box sx={theme.customStyles.valetActivitiesContainer}>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <Box sx={{ color: theme.palette.darkBlue.main, fontSize: "14px", fontWeight: theme.typography.fontWeightMedium }}>{currentActivity.name} {currentActivity.name === CAR_ARRIVED ? `at ${moment(currentActivity.timestamp).format("h:mm A")}` : ''}</Box>
          <Button onClick={() => setViewAllActivities(prev => !prev)} variant='text' sx={{ color: "#279AEB", fontSize: "14px", fontWeight: theme.typography.fontWeightMedium, fontFamily: theme.typography.fontFamily, textTransform: "none" }}>View All</Button>
        </Box>

        <Box {...bindDrag()} sx={{ marginTop: "8px" }}>
          <LinearProgress variant="determinate" value={activitiesPercentage} />
        </Box>

        <Box sx={{ marginTop: "16px", borderRadius: "8px", border: "1px solid #EFEFEF", padding: "16px" }}>
          {
            visibleActivities.map((activity, i) => (
              <Box key={i} sx={{ display: "flex", justifyContent: "flex-start", alignItems: "flex-start" }}>
                <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
                  <Box sx={{ ...theme.customStyles.circle, backgroundColor: activity.timestamp ? "#24A147" : "#DCDCDC" }}>
                    {activity.timestamp
                      ? <img src={RightTickImg} alt='Right Tick' width={15} height={12} />
                      : <Box sx={{ color: theme.palette.lightGray.main, fontSize: "14px", fontWeight: theme.typography.fontWeightRegular }}>{activity.id}</Box>
                    }
                  </Box>
                  {visibleActivities.length !== i + 1 && <Box sx={theme.customStyles.verticalLine}></Box>}
                </Box>
                <Box sx={{ marginLeft: "8px", marginTop: !activity.timestamp ? "5px" : "0px" }}>
                  <Box sx={{ color: theme.palette.darkBlue.main, fontSize: "14px", fontWeight: theme.typography.fontWeightMedium }}>{activity.name}</Box>
                  {activity.timestamp && <Box sx={{ color: theme.palette.lightGray.main, fontSize: "11px", fontWeight: theme.typography.fontWeightMedium }}>{moment(activity.timestamp).format('MMM D, YYYY • h:mm A')}</Box>}
                </Box>
              </Box>
            ))
          }
        </Box>
      </Box>
  )
}

export default VisibleActivities